export const getErrors = ({
  editError = {},
  deleteError = {},
  dataError = {},
  addError = {},
  projectsError = {},
  parseXmlError = {},
  parseXlsxError = {},
  addNewProjectError = {},
  editProjectError = {},
  projectXPathStructureError = {},
  checkAllXPathError = {},
  editXPathTargetShowCaseError = {},
  editProjectData = {},
  deleteProjectError = {},
}) => {
  return {
    fileXlsxInfoError:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      parseXlsxError?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      parseXlsxError?.data?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      parseXlsxError?.data?.error ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      projectXPathStructureError?.data ||
      null,
    xPathStructureError:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      projectXPathStructureError?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      projectXPathStructureError?.data?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      projectXPathStructureError?.data?.error ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      projectXPathStructureError?.data ||
      null,

    checkAllXPathErrorFormatted:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      checkAllXPathError?.data?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      checkAllXPathError?.data?.error ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      checkAllXPathError?.data ||
      null,
    editXPTSCError:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editXPathTargetShowCaseError?.data?.detail?.[0]?.msg ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editXPathTargetShowCaseError?.data?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editXPathTargetShowCaseError?.data?.error ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editXPathTargetShowCaseError?.data ||
      null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    editProjError:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editProjectError?.data?.detail?.[0]?.msg ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editProjectError?.data?.error ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editProjectError?.data ||
      null,

    newProjectError:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      addNewProjectError?.data?.detail?.[0]?.msg ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      addNewProjectError?.data?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      addNewProjectError?.data?.error ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      addNewProjectError?.data ||
      null,

    parseXlsxError:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      parseXlsxError?.data?.detail || parseXlsxError?.data?.error || parseXlsxError?.data || null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    parseXmlError: parseXmlError?.data?.error || parseXmlError?.data || null,

    editProjectsErrorData:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editProjectData?.data?.detail?.[0]?.msg ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editProjectData?.data?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      editProjectData?.data ||
      null,
    deleteProjectErrorData:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      deleteProjectError?.data?.detail?.[0]?.msg ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      deleteProjectError?.data?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      deleteProjectError?.data ||
      null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    projectsErrorData:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      projectsError?.data?.detail?.[0]?.msg ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      projectsError?.data?.detail ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      projectsError?.data ||
      null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    errorEditData: editError?.data || null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    errorDeleteData: deleteError?.data || null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    errorDeleteDetails: deleteError?.data?.detail || null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    errorDataDetails: dataError?.data?.detail || null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    errorEditDetails: editError?.data?.detail || null,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    errorAddDetails: addError?.data?.detail || null,
  };
};

export const getInitData = (data) => {
  return (
    data?.map((obj) => {
      return { ...obj, key: obj.id };
    }) || []
  );
};
